import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AvailibilityDatesService, AvailibilityItem, ListDates, SearchDispoService, TrackingService, WindowRefService } from '@app/core';
import * as moment from 'moment';
import { isArray } from 'rxjs/internal-compatibility';
@Component({
  selector: 'app-available-dates',
  templateUrl: './available-dates.component.html',
  styleUrls: ['./available-dates.component.scss']
})
export class AvailableDatesComponent implements OnInit {

  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  isDown = false;
  startX: number;
  scrollLeft: number;
  isAvailable: boolean = false;
  listDates: Array<any> = [];
  currentDateStart: moment.Moment;
  currentDateEnd: moment.Moment;

  constructor(private searchDispoService: SearchDispoService, private winRef: WindowRefService, private availibilityDatesService: AvailibilityDatesService, private trackingService: TrackingService) { }

  ngOnInit() {
    //used searchDispoService.allOtaLoaded to check if ota is loaded before check availibility dates
    // exemple: <app-available-dates *ngIf="searchDispoService.allOtaLoaded"></app-available-dates>

    let hasAvailableOta: boolean = /* this.searchDispoService.allOtaLoaded && */  this.searchDispoService.stockHasDispo;
    if (!hasAvailableOta) {
      this.currentDateStart = moment(this.winRef.appConfigSite.start);
      this.currentDateEnd = moment(this.winRef.appConfigSite.end);
      let start = moment(this.winRef.appConfigSite.start).locale('en').format('YYYY-MM-DD'),
        end = moment(this.winRef.appConfigSite.end).locale('en').format('YYYY-MM-DD'),
        adults = this.winRef.appConfigSite.adults,
        enfants = this.winRef.appConfigSite.enfants,
        currency = this.winRef.appConfigSite.Ccurrency,
        agesEnfants = this.winRef.appConfigSite.agesEnfants
        ;
      this.listDates = [];
      //this.isAvailable = false;
      this.availibilityDatesService.getDates(start, end, adults, enfants, agesEnfants, currency).subscribe((rep: Array<ListDates> | null) => {
        if (!!rep && isArray(rep)) {
          this.isAvailable = rep.length > 0;
          this.listDates = rep;
        }
      });
    }
  }

  /**
  * lang
  * @returns string lang
  */
  get lang(): string {
    return this.winRef.appConfigSite.defaultlangue
  }

  /**
  * get taux de change
  * @returns number
  */
  get Cpercente(): number {
    return this.winRef.appConfigSite.Cpercente;
  }

  /**
   * get currency
   * @returns string
   */
  get Ccurrency(): string {
    return this.winRef.appConfigSite.Ccurrency;
  }

  /**
   * changeDate
   */
  public changeDate(availibilityItem: AvailibilityItem) {
    this.winRef.appConfigSite.start = availibilityItem.startDate.toDate();
    this.winRef.appConfigSite.end = availibilityItem.endDate.toDate();
    let start = moment(this.winRef.appConfigSite.start).locale('en').format('YYYY-MM-DD'),
      end = moment(this.winRef.appConfigSite.end).locale('en').format('YYYY-MM-DD'),
      adults = this.winRef.appConfigSite.adults,
      enfants = this.winRef.appConfigSite.enfants,
      currency = this.winRef.appConfigSite.Ccurrency,
      agesEnfants = this.winRef.appConfigSite.agesEnfants
      ;
    this.trackingService.changeDates(start, end, adults, enfants, currency);
    const obj = this.winRef.generateNewUrlAndChanged(start, end, adults, enfants, agesEnfants);
    this.winRef.nativeWindow.location.href = obj.Url;
    this.winRef.nativeWindow.location.reload();//fix bug prices

  }

  onMouseDown(event: MouseEvent) {
    this.isDown = true;
    this.scrollContainer.nativeElement.classList.add('active');
    this.startX = event.pageX - this.scrollContainer.nativeElement.offsetLeft;
    this.scrollLeft = this.scrollContainer.nativeElement.scrollLeft;
  }

  onMouseLeave() {
    this.isDown = false;
    this.scrollContainer.nativeElement.classList.remove('active');
  }

  onMouseUp() {
    this.isDown = false;
    this.scrollContainer.nativeElement.classList.remove('active');
  }

  onMouseMove(event: MouseEvent) {
    if (!this.isDown) return;
    event.preventDefault();
    const x = event.pageX - this.scrollContainer.nativeElement.offsetLeft;
    const walk = (x - this.startX) * 3;
    this.scrollContainer.nativeElement.scrollLeft = this.scrollLeft - walk;
  }

}
